<template>
  <v-app>
    <v-app-bar app color="white" light class="lightly-shadowed" height="70px">
      <router-link :to="{ path: '/' }">
        <v-img src="./assets/cropped-logo-vertical@1x.png" class="mx-2" max-height="40" max-width="80"></v-img>
      </router-link>
    </v-app-bar>

    <v-content class="bg-white">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),

  mounted() {
    window.vueGoogleMapsInit(window.google)
  }
};
</script>
